import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';
import tagRecordings from '../../tracking/hotjar/tagRecordings';
import redirectTo from './redirectTo';

export default async function beforeEnterPreLoanOfferEbs(to, from, next) {
  try {
    const canEnter = await store.dispatch('canEnterPreLoanOfferEBS')
      .catch((e) => {
        throw new Error(e);
      });

    if (canEnter === 'redirect') {
      return;
    }

    if (!canEnter) {
      tagRecordings(['cannot_enter_pre_loan_offer_ebs']);
      store.dispatch('setBackendErrorMessage');
      redirectTo('/account_home', from.path);
    }
  } catch (e) {
    store.dispatch('setBackendErrorMessage');
    tagRecordings(['error_entering_pre_loan_offer_ebs']);
    captureRenderBlockingException(e);
    redirectTo('/account_home', from.path);
  } finally {
    store.dispatch('setAwaitingNavigation', false);
  }

  next();
}
